import {entity, BaseEntity, Pageable, Response} from "../../model";
import {ApiBuilder} from "..";

const addEntity = (builder: ApiBuilder) =>
  builder.mutation<Response<BaseEntity>, {payload: BaseEntity; entity: entity}>(
    {
      query: params => ({
        url: `/api/${params.entity}`,
        method: "POST",
        body: params.payload,
      }),
    },
  );

const updateEntity = (builder: ApiBuilder) =>
  builder.mutation<Response<BaseEntity>, {payload: BaseEntity; entity: entity}>(
    {
      query: params => ({
        url: `/api/${params.entity}/${params.payload.id}`,
        method: "PATCH",
        body: params.payload,
      }),
    },
  );

const findEntityById = (builder: ApiBuilder) =>
  builder.query<BaseEntity, {id: string; entity: entity}>({
    query: params => ({url: `/api/${params.entity}/${params.id}`}),
    transformResponse: (response: Response<BaseEntity>) => {
      return response.data;
    },
    providesTags: (_data, _err, params) => [
      {type: params.entity, id: params.id},
    ],
  });

const deleteEntityById = (builder: ApiBuilder) =>
  builder.mutation<void, {id: string; entity: entity}>({
    query: params => ({
      url: `/api/${params.entity}/${params.id}`,
      method: "DELETE",
    }),
  });

export enum SearchParamOperator {
  EQ = "EQ",
  GT = "GT",
  GTE = "GTE",
  LT = "LT",
  LTE = "LTE",
  BETWEEN = "BETWEEN",
  IN = "IN",
  NOT_IN = "NOT_IN",
  NE = "NE",
  LIKE = "LIKE",
}

export type SearchFilterParam = {
  name: string;
  operator: SearchParamOperator;
  values: (string | number)[];
};

type SearchFilter = {
  exprType: "allOf" | "anyOf";
  params: SearchFilterParam[];
};

export type SearchParams = {
  page: number;
  size: number;
  sort?: string[]; // es: ["name,asc", "date,desc"]
  filter?: SearchFilter;
};

const advancedSearch = (builder: ApiBuilder) =>
  builder.query<Pageable<BaseEntity>, {entity: entity; body: SearchParams}>({
    query: params => ({
      url: `/api/${params.entity}/search`,
      method: "POST",
      body: params.body,
    }),
    transformResponse: (response: Response<Pageable<BaseEntity>>) => {
      return response.data;
    },
  });

export {
  updateEntity,
  findEntityById,
  deleteEntityById,
  addEntity,
  advancedSearch,
};
